import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const IconWidthSpan = styled.span`
  display: flex;
  align-items: center;
  img {
    margin-right: 1rem;
  }
`;

const IconComponent = (props) => {
  const { className, iconUrl, iconAlt, children } = props;
  return (
    <IconWidthSpan className={className}>
      <img src={iconUrl} align="left" alt={iconAlt} aria-hidden="true" />
      <span>
        {children}
      </span>
    </IconWidthSpan>
  );
};

IconComponent.propTypes = {
  iconUrl: PropTypes.string.isRequired,
  iconAlt: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

IconComponent.defaultProps = {
  className: '',
};

export default IconComponent;



// WEBPACK FOOTER //
// ./src/components/IntroPanel/IconComponent.js